// imgbb-upload.service.ts

import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { resolve } from 'dns/promises';
import { rejects } from 'assert';
import { MasterDataSeriveService } from './master-data-serive.service';

@Injectable({
  providedIn: 'root'
})
export class ImgUploaderService {
  private apiKey = 'a68bcf30a825013ebf198124f5b1dab6';
  private apiUrl = 'https://api.imgbb.com/1/upload';
  private baseUrl = '';

  constructor(private http: HttpClient, @Inject('BASE_URL') private webUrl: string, private masterService: MasterDataSeriveService) {
    let user = this.masterService.getUserDetailsFromStorage();
    this.baseUrl = `${this.webUrl}BlobFiles/Upload?path=tpm-products&companyId=${user.companyID}`;
  }

  uploadImage(file: File): Observable<any> {
    const formData = new FormData();
    let fileName = new Date().toISOString();
    formData.append('File', file);
    formData.append('FileName', fileName);

    return this.http.post<string>(this.baseUrl, formData)
      .pipe(
        catchError(this.handleError)
      );
  }

  productImageUpload(file: File): Promise<any> {
    let userdetails = this.masterService.getUserDetailsFromStorage();
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', file);
      const params = new HttpParams()
        .set('path', 'images')
        .set('companyId', userdetails.companyID.toString());

      this.http
        .post<string>(this.baseUrl, formData)
        .toPromise()
        .then((response) => {
          if (response) {
            resolve(response);
          } else {
            reject(new Error('Upload failed: Response was undefined.'));
          }
        })
        .catch((error) => {
          reject(this.handleError(error)); // Handle error as needed
        });
    });
  }

  addTaxDocImageUpload(file: File) {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('key', this.apiKey);
    return this.http.post<any>(this.apiUrl, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  productImageLogoUpload(file: File, originalFileName: string): Promise<any> {

    return new Promise((resolve, reject) => {
      const formData = new FormData();

      // Use the original file name instead of a generated one
      formData.append('File', file);
      formData.append('FileName', originalFileName);

      this.http.post<string>(this.baseUrl, formData)
        .toPromise()
        .then((response) => {
          if (response) {
            resolve(response);
          } else {
            reject(new Error('Upload failed: Response was undefined.'));
          }
        })
        .catch((error) => {
          reject(this.handleError(error)); // Handle error as needed
        });
    });
  }

  private handleError(error: HttpErrorResponse): Observable<never> {

    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    return throwError('Something went wrong; please try again later.');
  }
}
